import * as React from 'react'
import { useQuery } from '@apollo/client'
import styled from 'styled-components'
import { Query_Root } from '../../graphql/indexer-graphql-types'
import { PUBLIC_METRICS_QUERY } from '../../graphql/graphql-queries'
import { LAMPORTS_PER_SOL } from '@solana/web3.js'
import moment from 'moment'
import { useMediaQuery } from '@material-ui/core'
import Marquee from 'react-fast-marquee'

const MetricsDiv = styled.div`
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100vw;
  /* background-color: black; */
  /* border-bottom: 1px solid #323232; */

  height: 25px;

  @media (min-width: 62em) {
    gap: 25px;
  }
`

const TextDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: fit-content;
  margin-right: 15px;

  @media (min-width: 43em) {
    margin-right: 25px;
  }

  @media (min-width: 62em) {
    margin: 0;
    width: fit-content;
  }
`

const Text = styled.span<{ bold?: boolean }>`
  color: ${(props) => (props.bold ? 'white' : '#aaa')};
  text-transform: uppercase;
  font-size: 10px;
  font-weight: ${(props) => (props.bold ? 700 : 400)};
  text-align: center;
  white-space: pre;

  @media (min-width: 43em) {
    font-size: 12px;
  }

  @media (min-width: 62em) {
    text-align: center;
  }
`

const Metrics = (): JSX.Element => {
  const date = React.useRef(new Date())
  const isTablet = useMediaQuery('(max-width: 62em)')
  const result = useQuery<Query_Root>(PUBLIC_METRICS_QUERY, {
    variables: {
      from: moment(date.current).subtract(1, 'days').unix(),
    },
  })

  const metricsData = result.data

  const totalPrimaryVolume: number = (metricsData?.primaryReceiptAggregate.aggregate?.sum as any)
    ?.total_primary_volume
  const numberOfPrimarySales: number = (metricsData?.primaryReceiptAggregate.aggregate as any)
    ?.number_of_primary_sales
  const totalSecondaryVolume: number = (metricsData?.purchaseReceiptAggregate.aggregate?.sum as any)
    ?.total_secondary_volume
  const numberOfSecondarySales: number = (metricsData?.purchaseReceiptAggregate.aggregate as any)
    ?.number_of_secondary_sales
  const primaryVolume24hrs: number = (metricsData as any)?.primaryReceiptAggregate24Hours?.aggregate
    ?.sum?.primary_volume_24hrs
  // const numberOfPrimarySales24hrs: number = (metricsData as any)?.primaryReceiptAggregate24Hours
  //   ?.aggregate?.number_of_primary_sales_24hrs
  const secondaryVolume24hrs: number = (metricsData as any)?.purchaseReceiptAggregate24Hours
    ?.aggregate?.sum?.secondary_volume_24hrs
  // const numberOfSecondarySales24hrs: number = (metricsData as any)?.purchaseReceiptAggregate24Hours
  //   ?.aggregate?.number_of_secondary_sales_24hrs

  const totalVolume: string = (
    (totalPrimaryVolume + totalSecondaryVolume) / LAMPORTS_PER_SOL -
    0.17
  ).toFixed(2)
  const totalVolume24hrs: string = (
    (primaryVolume24hrs + secondaryVolume24hrs) /
    LAMPORTS_PER_SOL
  ).toFixed(2)
  const numberOfSales: number = numberOfPrimarySales + numberOfSecondarySales - 7
  // const numberOfSales24hrs: number = numberOfPrimarySales24hrs + numberOfSecondarySales24hrs

  const uniqueCollectors: number = (metricsData?.tokenAccountAggregate.aggregate as any)
    ?.unique_collectors
  const numberOfVideos: number = (metricsData?.mintAggregate.aggregate as any)?.number_of_videos - 2
  const uniqueCreators: number =
    (metricsData?.creatorAggregate.aggregate as any)?.unique_creators - 3

  return isTablet ? (
    <MetricsDiv>
      <Marquee gradientColor={[16, 16, 16]} delay={0} speed={50} gradientWidth={50}>
        {Number(totalVolume24hrs) > 10 && (
          <TextDiv>
            <Text>{`24H Volume: `}</Text>
            <Text bold>{`${totalVolume24hrs} SOL`}</Text>
          </TextDiv>
        )}
        <TextDiv>
          <Text>{`Total Volume: `}</Text>
          <Text bold>{`${totalVolume} SOL`}</Text>
        </TextDiv>
        {/* <TextDiv>
          <Text>{`24H Sales: `}</Text>
          <Text bold>{`${numberOfSales24hrs}`}</Text>
        </TextDiv> */}
        <TextDiv>
          <Text>{`Total Sales: `}</Text>
          <Text bold>{`${numberOfSales}`}</Text>
        </TextDiv>
        <TextDiv>
          <Text>{`Collectors: `}</Text>
          <Text bold>{`${uniqueCollectors}`}</Text>
        </TextDiv>
        <TextDiv>
          <Text>{`Creators: `}</Text>
          <Text bold>{`${uniqueCreators}`}</Text>
        </TextDiv>
        <TextDiv>
          <Text>{`Videos: `}</Text>
          <Text bold>{`${numberOfVideos}`}</Text>
        </TextDiv>
        {Number(totalVolume24hrs) > 10 && (
          <TextDiv>
            <Text>{`24H Volume: `}</Text>
            <Text bold>{`${totalVolume24hrs} SOL`}</Text>
          </TextDiv>
        )}
        <TextDiv>
          <Text>{`Total Volume: `}</Text>
          <Text bold>{`${totalVolume} SOL`}</Text>
        </TextDiv>
        <TextDiv>
          <Text>{`Total Sales: `}</Text>
          <Text bold>{`${numberOfSales}`}</Text>
        </TextDiv>
        <TextDiv>
          <Text>{`Collectors: `}</Text>
          <Text bold>{`${uniqueCollectors}`}</Text>
        </TextDiv>
        <TextDiv>
          <Text>{`Creators: `}</Text>
          <Text bold>{`${uniqueCreators}`}</Text>
        </TextDiv>
        <TextDiv>
          <Text>{`Videos: `}</Text>
          <Text bold>{`${numberOfVideos}`}</Text>
        </TextDiv>
      </Marquee>
    </MetricsDiv>
  ) : (
    <MetricsDiv>
      {Number(totalVolume24hrs) > 10 && (
        <TextDiv>
          <Text>{`24H Volume: `}</Text>
          <Text bold>{`${totalVolume24hrs} SOL`}</Text>
        </TextDiv>
      )}
      <TextDiv>
        <Text>{`Total Volume: `}</Text>
        <Text bold>{`${totalVolume} SOL`}</Text>
      </TextDiv>
      {/* <TextDiv>
        <Text>{`24H Sales: `}</Text>
        <Text bold>{`${numberOfSales24hrs}`}</Text>
      </TextDiv> */}
      <TextDiv>
        <Text>{`Total Sales: `}</Text>
        <Text bold>{`${numberOfSales}`}</Text>
      </TextDiv>
      <TextDiv>
        <Text>{`Creators: `}</Text>
        <Text bold>{`${uniqueCreators}`}</Text>
      </TextDiv>
      <TextDiv>
        <Text>{`Collectors: `}</Text>
        <Text bold>{`${uniqueCollectors}`}</Text>
      </TextDiv>
      <TextDiv>
        <Text>{`Videos: `}</Text>
        <Text bold>{`${numberOfVideos}`}</Text>
      </TextDiv>
    </MetricsDiv>
  )
}

export default Metrics

{
  /* <TextDiv>
  <Text>{`On Ethereum? Check out the first videos from our OG creators on the `}</Text>
  <Text
    bold
    style={{ cursor: 'pointer' }}
    onClick={() => window.open('https://glass.xyz', '_blank')} // update to new beta link
  >{`Glass Beta ->`}</Text>
</TextDiv>
<TextDiv>
  <Text>{`We updated our `}</Text>
  <Text
    bold
    style={{ cursor: 'pointer' }}
    onClick={() => window.open('https://glass-privacy.super.site', '_blank')}
  >{`Privacy Policy`}</Text>
  <Text>{` and `}</Text>
  <Text
    bold
    style={{ cursor: 'pointer' }}
    onClick={() => window.open('https://glass-terms.super.site', '_blank')}
  >{`Terms of Use`}</Text>
  <Text>{`.  By continuing to use Glass, you're agreeing to our updated Policy and Terms.`}</Text>
</TextDiv> */
}
